import './App.css';
import AddressInput from './AddressInput';

function App() {
  return (
    <div className="App">
      <h1>Collaborate Late NYC</h1>
      <AddressInput />
    </div>
  );
}

export default App;
